export default "__VITE_ASSET__DoHs3mgC__"